export default __webpack_public_path__ + "static/media/lung4.69625cfe.jpg";